import { useQuery } from '@apollo/client'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import { GET_CLASH_COUNT } from 'api/graphQL/queries/bestPracticeClash.queries'
import { ClashList } from 'components/BestPracticeClash/ClashList'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
    title: {
        fontSize: pxToRem(16),
        fontWeight: 600,
        color: '#04325B',
        marginBottom: theme.spacing(1),
    },
    titleGridItem: {
        position: 'absolute',
        width: '100%',
        height: '45px',
        display: 'flex',
        alignItems: 'center',
        background: '#1d49661a',
        zIndex: 1,
    },
    formSidebar: {
        minWidth: pxToRem(268),
        width: '100%',
        maxHeight: pxToRem(550),
        flexDirection: 'inherit',
        position: 'relative',
        top: 8,
        left: 8,
    },
    propertiesContainer: {
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: pxToRem(550),
        paddingRight: theme.spacing(1),
        width: '100%',
    },
    toggleContainer: {
        width: '100%',
        flex: 1,
        overflow: 'hidden',
        marginTop: pxToRem(45),
    },
}))

interface ClashesPaneProps {
    selectedTopic?: any // For consistency with other panes
    treePath?: string | null // tree path to filter clashes for specific family instance
}

export const ClashesPane = ({ selectedTopic, treePath }: ClashesPaneProps) => {
    const classes = useStyles()
    const { projectId } = useParams<{ projectId: string }>()
    const [refreshKey, setRefreshKey] = useState(0)

    // Query for count to display in header badge
    const { data: countData, refetch: refetchCount } = useQuery(
        GET_CLASH_COUNT,
        {
            variables: {
                input: {
                    projectId: projectId,
                    treePath: treePath,
                },
            },
            skip: !projectId,
            fetchPolicy: 'cache-and-network',
        }
    )

    const unresolvedCount = countData?.bestPracticeClashCount ?? 0

    const handleClashResolved = () => {
        // Refetch count when a clash is resolved
        refetchCount()
    }

    return (
        <GridContainer
            direction="column"
            data-testid="workspaceFormSideBar"
            className={classes.formSidebar}
            spacing={2}
        >
            <GridItem className={classes.titleGridItem}>
                <Typography className={classes.title} component="div">
                    Best Practice Clashes
                </Typography>
            </GridItem>

            <GridItem className={classes.toggleContainer}>
                <GridItem className={classes.propertiesContainer}>
                    <ClashList
                        key={refreshKey}
                        projectId={projectId}
                        treePath={treePath}
                        onClashResolved={handleClashResolved}
                        fullWidth
                    />
                </GridItem>
            </GridItem>
        </GridContainer>
    )
}
